import * as Sentry from "@sentry/vue"
import { App } from "vue"

const TAXA_DE_AMOSTRAGEM_DE_ERROS = 0.0001

export default function (app: App): void {
  // TODO: Comentando já que atualmente não está funcionando e está pedindo cobertura de testes, impedindo de subir o PR do card #1451
  // const verificarAmbiente = (ambienteAtual: string, ambienteEsperado: string) => {
  //   return ambienteAtual === ambienteEsperado;
  // }

  // const ambienteNode = process.env.NODE_ENV;
  // const ehAmbienteDoCliente = verificarAmbiente(ambienteNode, "production");
  // const ehAmbienteDeDesenvolvimento = verificarAmbiente(ambienteNode, "development");

  // const inicializarSentry = () => {
  //   if (ehAmbienteDoCliente) {
  //     Sentry.init({
  //       app,
  //       dsn: "https://19bc14350e2140ffbc0afc8419b37436@sentry.pontotel.com.br/15",
  //       logErrors: true,
  //       tracesSampleRate: TAXA_DE_AMOSTRAGEM_DE_ERROS,
  //     });
  //   }
  // }

  // const configurarTratadorDeAvisos = () => {
  //   app.config.warnHandler = (mensagem, instancia, pilhaDeRastreamento) => {
  //     if (ehAmbienteDeDesenvolvimento) {
  //       console.warn(mensagem, instancia, pilhaDeRastreamento)
  //     }

  //     if (ehAmbienteDoCliente) {
  //       Sentry.captureMessage(mensagem, { extra: { pilhaDeRastreamento, instancia } })
  //     }
  //   }
  // }

  // const configurarTratadorDeErros = () => {
  //   app.config.errorHandler = (erro, instancia, pilhaDeRastreamento) => {
  //     if (ehAmbienteDeDesenvolvimento) {
  //       console.error(erro, instancia, pilhaDeRastreamento)
  //     }

  //     if (ehAmbienteDoCliente) {
  //       Sentry.captureException(erro, { extra: { pilhaDeRastreamento, instancia } })
  //     }
  //   }
  // }

  // const definirTagsParaSentry = () => {
  //   Sentry.setTag("ambiente", ambienteNode);
  // }

  // definirTagsParaSentry();
  // inicializarSentry();
  // configurarTratadorDeAvisos();
  // configurarTratadorDeErros();

  app.config.compilerOptions.comments = false
}
